import React from 'react';

import { Banner } from '@repo/common';

import { ReactComponent as IdeaIcon } from '@repo/common/assets/icons/20px/icon_20px_idea-outline.svg';

const LanguageSkillsBanner = () => {
  return (
    <div className='min-w-[280px] max-w-[348px] w-full flex flex-col items-start gap-2'>
      <Banner
        type='info'
        size='s'
        label='Use the official certification name when 
applicable. If you do not hold a certification, list 
the language you can actively use for work.'
        labelKr={
          '해당하는 경우 공식 자격증 이름을 사용해 주세요.\n자격증이 없다면 업무에서 실제로 사용할 수 있는\n언어를 작성해 주세요.'
        }
        hideButton
        hideClose
        icon={<IdeaIcon />}
      />
    </div>
  );
};

export default LanguageSkillsBanner;
